angular.module('rjmNg.directives').directive "backgroundOverlay", [
  () ->
    restrict: "A"
    controller: [
      "$scope"
      (
        $scope
      ) ->
        $body = $('body')

        addBackgroundOverlay = () ->
          $body.addClass("rj-background-overlay")

        removeBackgroundOverlay = () ->
          $body.removeClass("rj-background-overlay")

        $scope.$on('beginTourSteps', () ->
            addBackgroundOverlay()
          )

        $scope.$on('endOfTour', () ->
          removeBackgroundOverlay()
          )
    ]
]
